var _react_refresh_temp_1, _react_refresh_temp_2;
var _react_refresh_temp_3;
_react_refresh_temp_3 = $RefreshSig$();
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useEffect, useRef, useState } from 'react';
import { toast } from 'react-toastify';
import { useTranslation } from 'react-i18next';
import { createSelector } from '@reduxjs/toolkit';
import { store, useAppSelector } from '../../../store';
import { isSocketConnected, sendAnalyticsByWebsocket, sendWebsocketMessage, } from '../../../helpers/websocket';
import useResumableFilesUpload from '../../../helpers/hooks/useResumableFilesUpload';
import { DataMessage, DataMsgBodyType, DataMsgType, } from '../../../helpers/proto/plugnmeet_datamessage_pb';
import { AnalyticsEvents, AnalyticsEventType, } from '../../../helpers/proto/plugnmeet_analytics_pb';
const selectedChatOptionSelector = createSelector(_react_refresh_temp_1 = (state) => state.roomSettings, (roomSettings) => roomSettings.selectedChatOption);
$RefreshReg$(_react_refresh_temp_1, "selectedChatOptionSelector$createSelector");
const FileSend = ({ isChatServiceReady, lockSendFile, currentRoom, }) => {
    var _a, _b, _c, _d;
    _react_refresh_temp_3();
    const inputFile = useRef(null);
    const { t } = useTranslation();
    const [files, setFiles] = useState();
    const selectedChatOption = useAppSelector(selectedChatOptionSelector);
    const chat_features = (_a = store.getState().session.currentRoom.metadata) === null || _a === void 0 ? void 0 : _a.room_features.chat_features;
    const accept = (_c = (_b = chat_features === null || chat_features === void 0 ? void 0 : chat_features.allowed_file_types) === null || _b === void 0 ? void 0 : _b.map((type) => '.' + type).join(',')) !== null && _c !== void 0 ? _c : '*';
    const maxFileSize = (chat_features === null || chat_features === void 0 ? void 0 : chat_features.max_file_size)
        ? chat_features === null || chat_features === void 0 ? void 0 : chat_features.max_file_size
        : undefined;
    const { isUploading, result } = useResumableFilesUpload({
        allowedFileTypes: (_d = chat_features === null || chat_features === void 0 ? void 0 : chat_features.allowed_file_types) !== null && _d !== void 0 ? _d : [],
        maxFileSize,
        files,
    });
    useEffect(() => {
        if (result && result.filePath && result.fileName) {
            publishToChat(result.filePath, result.fileName);
            toast(t('right-panel.file-upload-success'), {
                type: 'success',
            });
        }
    }, [result]);
    const openFileBrowser = () => {
        var _a;
        if (!isUploading) {
            (_a = inputFile.current) === null || _a === void 0 ? void 0 : _a.click();
        }
    };
    const onChange = (e) => {
        const files = e.target.files;
        if (!files.length) {
            return;
        }
        setFiles([...files]);
    };
    const publishToChat = (filePath, fileName) => {
        if (!isSocketConnected()) {
            return;
        }
        const message = `<span class="download"> <i class="pnm-download"></i> <a href="${window.PLUG_N_MEET_SERVER_URL +
            '/download/uploadedFile/' +
            filePath}" target="_blank">${fileName}</a></span>`;
        const dataMsg = new DataMessage({
            type: DataMsgType.USER,
            roomSid: currentRoom.sid,
            roomId: currentRoom.name,
            to: selectedChatOption !== 'public' ? selectedChatOption : '',
            body: {
                type: DataMsgBodyType.CHAT,
                isPrivate: selectedChatOption !== 'public' ? 1 : 0,
                from: {
                    sid: currentRoom.localParticipant.sid,
                    userId: currentRoom.localParticipant.identity,
                    name: currentRoom.localParticipant.name,
                },
                msg: message,
            },
        });
        sendWebsocketMessage(dataMsg.toBinary());
        // send analytics
        sendAnalyticsByWebsocket(AnalyticsEvents.ANALYTICS_EVENT_USER_CHAT_FILES, AnalyticsEventType.USER, fileName);
    };
    const render = () => {
        return (_jsxs(_Fragment, { children: [_jsx("input", { type: "file", id: "chat-file", ref: inputFile, accept: accept, style: { display: 'none' }, onChange: (e) => onChange(e) }), _jsx("button", { disabled: !isChatServiceReady || lockSendFile || isUploading, onClick: () => openFileBrowser(), className: "w-4 h-6 px-2", children: _jsx("i", { className: "pnm-attachment primaryColor text-[20px] opacity-50 dark:text-secondaryColor" }) })] }));
    };
    return _jsx(_Fragment, { children: render() });
};
_react_refresh_temp_2 = FileSend;
$RefreshReg$(_react_refresh_temp_2, "FileSend");
_react_refresh_temp_3(FileSend, "ms9u2F5tSzbp2iitt92Nx8w9/Sw=", false, () => [useTranslation, useAppSelector, useResumableFilesUpload]);
export default FileSend;
